import { useCallback, useRef, useState } from "react";
import { toast } from "sonner";

/**
 * Eksport z DataTable przez `onExportReady` (wzorzec `dzzf-flags-monthly-page`):
 * funkcja w refie, w stanie tylko „gotowe”. DataTable podaje nową funkcję przy
 * każdym renderze (np. domyślne `summableColumns = []`), więc trzymanie jej w
 * stanie kręci pętlę renderów.
 */
export function useTableExport() {
	const fnRef = useRef<(() => Promise<void>) | null>(null);
	const [ready, setReady] = useState(false);
	const [exporting, setExporting] = useState(false);
	const onExportReady = useCallback((fn: () => Promise<void>) => {
		fnRef.current = fn;
		setReady(true);
	}, []);
	const run = useCallback(async () => {
		if (!fnRef.current) return;
		setExporting(true);
		try {
			await fnRef.current();
		} catch (e) {
			toast.error(e instanceof Error ? e.message : "Eksport nie powiódł się");
		} finally {
			setExporting(false);
		}
	}, []);
	return { ready, exporting, onExportReady, run };
}
